import { createTheme } from "@mui/material/styles";
import { red, grey } from "@mui/material/colors";

const fleasingTypography = {
  fontFamily: `"Raleway", "Arial", sans-serif`,
  h1: {
    fontSize: "3rem", // ~48px
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
  },
  h2: {
    fontSize: "2.5rem", // ~40px
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: "-0.015em",
  },
  h3: {
    fontSize: "2rem", // ~32px
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: "-0.01em",
  },
  h4: {
    fontSize: "1.75rem", // ~28px
    fontWeight: 500,
    lineHeight: 1.35,
  },
  h5: {
    fontSize: "1.5rem", // ~24px
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h6: {
    fontSize: "1.25rem", // ~20px
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subtitle1: {
    fontSize: "1.125rem", // ~18px
    fontWeight: 500,
    lineHeight: 1.6,
    color: "#4E6EA9",
  },
  subtitle2: {
    fontSize: "1rem", // ~16px
    fontWeight: 500,
    lineHeight: 1.6,
    color: "#4E6EA9",
  },
  body1: {
    fontSize: "1rem", // ~16px
    fontWeight: 400,
    lineHeight: 1.6,
    color: "#1A3C6E",
  },
  body2: {
    fontSize: "0.875rem", // ~14px
    fontWeight: 400,
    lineHeight: 1.6,
    color: "#4E6EA9",
  },
  button: {
    fontSize: "1rem", // ~16px
    fontWeight: 600,
    textTransform: "none",
  },
  caption: {
    fontSize: "0.75rem", // ~12px
    fontWeight: 400,
    lineHeight: 1.4,
    color: "#4E6EA9",
  },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },
};

// Define the Fleasing color palette
const fleasingPalette = {
  primary: {
    main: "#1A3C6E", // Deep blue (logo/nav)
    light: "#4E6EA9",
    dark: "#102A4E",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#FEC601", // Yellow (CTA buttons)
    light: "#FFD633",
    dark: "#C79C00",
    contrastText: "#1A3C6E",
  },
  error: {
    main: red[700],
  },
  background: {
    default: "#F4F6F9", // Light grey background
    paper: "#FFFFFF", // White cards
  },
  text: {
    primary: "#1A3C6E",
    secondary: grey[600],
  },
};

// Create the custom MUI theme
const theme = createTheme({
  palette: fleasingPalette,
  typography: fleasingTypography,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
          fontWeight: 600,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          padding: "16px",
        },
      },
    },
  },
});

export default theme;